<template>
    <div>
        <Field v-model="content" :field="field" @error="error" v-bind="$attrs" :extendErrors="errors" :store="$store" />
        <slot></slot>
    </div>
</template>

<script>
import IdentityFields from '../identityFields/IdentityFields'
import _ from 'lodash'

export default {
    name: 'Image',
    components: {
        Field: IdentityFields
    },
    props: {
        label: {
            type: String
        },
        value: {
            type: String | Number
        },
        name: {
            type: String
        },
        rules: {
            type: Object
        },
        type: {
            type: String,
            default: 'text'
        },
        description: {
            type: String,
        },
        errors: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: 'image'
        },
        publicUpload: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            field: {
                type: this.type,
                module: "input",
                key: this.name,
                name: this.label,
                description: this.description,
                constraints: {}
            }
        }
    },
    computed: {
        content: {
            get() {
                let valObj = {}
                valObj[this.field.key] = this.value

                return valObj
            },

            set(val) {
                if (this.rules.expression !== undefined) {
                    this.errors = this.rules.expression(val)
                    this.error({
                        field: this.name,
                        error: this.errors.length > 0
                    })
                }

                this.$emit('input', val[this.field.key])
            }
        }
    },
    methods: {
        error(errors) {
            this.$emit('error', errors)
        }
    },

    mounted() {
        this.$store.dispatch("fetchLibraries").then(libraries => {
            let libs = libraries.map(l => {
                return l.uuid
            })

            let defLib = libraries[0]
            if (defLib) {
                defLib = defLib.uuid
            }

            this.field.constraints.custom_data = {
                image: {
                    chooseFromLibrary: true,
                    chooseFromDevice: true,
                    chooseExternalSource: true,
                    libraries: libs,
                    defaultLibrary: defLib,
                    publicUpload: this.publicUpload
                }
            }
        })

        
    }
}
</script>